import { getCurrentLocation } from '../../services/location.service';

/**
 * Capture GPS silently for job status changes (no UI warnings or toasts)
 */
export async function captureJobLocationSilently() {
  try {
    return await getCurrentLocation({
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 60000,
    });
  } catch {
    return null;
  }
}

/**
 * Build GraphQL JobStatusGPSInput from a captured browser location
 */
export function buildJobStatusGPSInput(location) {
  if (location?.latitude == null || location?.longitude == null) {
    return null;
  }
  return {
    latitude: location.latitude,
    longitude: location.longitude,
    accuracy: location.accuracy ?? null,
  };
}
